import React from "react";
import "./ProductFooter.css";
import { Link } from "react-router-dom";

function ProductFooter() {
  return (
    <div className="productfooter">
      <div className="firstrow-footer d-flex">
        <p className="col-4">
          <Link to="/productsByBrand">KINVENT</Link>
        </p>
        <p className="col-4">
          <Link to="/productsByBrand">WONDER</Link>
        </p>
        <p className="col-4 firstrow-lastp">
          <Link to="/productsByBrand">BTL</Link>
        </p>
      </div>
      <div className="second-row d-flex">
        <p className="col-4 secondrow-firstp">
          <Link to="/productsByBrand">CLASSYS</Link>
        </p>
        <p className="col-4 secondrow-secondp">
          <Link to="/productsByBrand">STARVAC</Link>
        </p>
        <p className="col-4 secondriw-thirdp">
          <Link to="/productsByBrand">CRYOSKIN</Link>
        </p>
      </div>
    </div>
  );
}

export default ProductFooter;
